import type { MutableState } from '../State';
import { getDayStats } from './stats.getters';
import {
  DayStats,
  PersistentStats,
  initialDayStats,
  initialPersistentStats,
} from './stats.ruleset';

/**
 * Increment lifetime stats of user activity
 */
export function incrementPersistentStat(
  state: MutableState,
  id: PersistentStats,
): void {
  if (!state.stats) state.stats = {};
  if (!state.stats[id]) state.stats[id] = initialPersistentStats[id];
  state.stats[id] += 1;
}

/**
 * Set persistent stats of user activity
 */
export function setPersistentStat(
  state: MutableState,
  id: PersistentStats,
  value: number = 1,
): void {
  if (!state.stats) state.stats = {};
  state.stats[id] = value;
}

/**
 * Increment day stats of user activity
 */
export function incrementDayStat(
  state: MutableState,
  id: DayStats,
  now: number,
): void {
  const config = initialDayStats[id];

  // Initialize the day stats if it doesn't exist
  if (!state.dayStats) state.dayStats = {};
  if (!state.dayStats[id])
    state.dayStats[id] = { updatedAt: now, counter: config.initial };

  // Use getDay to determine the current counter value and increment it
  state.dayStats[id].counter = getDayStats(state, id, now) + 1;

  // Update the last update timestamp
  state.dayStats[id].updatedAt = now;
}

/**
 * Set day stats of user activity
 */
export function setDayStat(
  state: MutableState,
  id: DayStats,
  value: number,
  now: number,
): void {
  if (!state.dayStats) state.dayStats = {};
  state.dayStats[id] = { updatedAt: now, counter: value };
}
